"use client";
import {
  useDialogStoreProps
} from "./6SB7F42L.js";
import {
  useStore,
  useStoreProps
} from "./4OZYHFMH.js";
import {
  useUpdateEffect
} from "./6O5OEQGF.js";

// src/popover/popover-store.ts
import * as Core from "@ariakit/core/popover/popover-store";
function usePopoverStoreProps(store, update, props) {
  useUpdateEffect(update, [props.popover]);
  store = useDialogStoreProps(store, update, props);
  useStoreProps(store, props, "placement");
  return store;
}
function usePopoverStore(props = {}) {
  const [store, update] = useStore(Core.createPopoverStore, props);
  return usePopoverStoreProps(store, update, props);
}

export {
  usePopoverStoreProps,
  usePopoverStore
};
